/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const requestCvUpdateResponseSchema = z.object({
  emailSent: z.boolean(),
  requestedAt: z.string().datetime({ local: true }),
});
